import { z } from 'zod/v4';

/**
 * Data shape for the `indent` (spacer) widget — a single flag. The spacer's only
 * real setting is its height, which lives in the envelope's typed `styles` /
 * `mobileStyles` bags (see `./styles`); `data` just records whether the two are
 * kept in sync.
 *
 * `isSynchronizeStyle` is nullable because very old widgets persist `null`.
 * **Unlike button/text, `null` means ON here** — the FormGroup control seeded the
 * field with `true` whenever it read `null`, so the divider between "off" and
 * "never set" is preserved by the form's `isSynchronized` accessor.
 */
export const indentLegacyDataSchema = z.object({
    isSynchronizeStyle: z.boolean().nullable(),
});
